import { render, staticRenderFns } from "./Snack.vue?vue&type=template&id=0895cd3d&scoped=true&"
import script from "./Snack.vue?vue&type=script&lang=js&"
export * from "./Snack.vue?vue&type=script&lang=js&"
import style0 from "./Snack.vue?vue&type=style&index=0&id=0895cd3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895cd3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VContainer,VIcon})
